import React, { useState, useRef } from 'react';
import { apiPostFormData } from '../utils/api';
import '../styles/Feedback.css';

export default function Feedback() {
  const [feedback, setFeedback] = useState('');
  const [screenshot, setScreenshot] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const fileInputRef = useRef(null);

  const handleScreenshotChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setScreenshot(file);
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('feedback', feedback);
      if (screenshot) {
        formData.append('screenshot', screenshot);
      }

      await apiPostFormData('/feedback', formData);

      setSubmitted(true);
      setFeedback('');
      setScreenshot(null);
      setPreviewUrl('');
    } catch (error) {
      setError(error.message || 'Failed to submit feedback. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith('image/')) {
      setScreenshot(file);
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
      setError('');
    }
  };

  const removeScreenshot = () => {
    setScreenshot(null);
    setPreviewUrl('');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  if (submitted) {
    return (
      <div className="feedback-container">
        <div className="success-message">
          <h2>Thank you for your feedback!</h2>
          <p>Your feedback has been submitted successfully.</p>
          <button 
            onClick={() => setSubmitted(false)} 
            className="submit-button"
          >
            Submit Another Feedback
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="feedback-container">
      <h2>Feedback & Issues</h2>
      <form onSubmit={handleSubmit}>
        <textarea
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          placeholder="Please share your feedback or report any issues..."
          rows="6"
          className="feedback-textarea"
          required
        />
        
        <div 
          className="screenshot-upload-area"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleScreenshotChange}
            className="file-input"
            ref={fileInputRef}
            id="screenshot-input"
          />
          <label htmlFor="screenshot-input" className="upload-label">
            <span className="upload-icon">📷</span>
            Drag & drop a screenshot or click to upload
          </label>
        </div>

        {previewUrl && (
          <div className="screenshot-preview">
            <img src={previewUrl} alt="Screenshot preview" />
            <button 
              type="button" 
              onClick={removeScreenshot}
              className="remove-screenshot"
            >
              ✕
            </button>
          </div>
        )}

        {error && (
          <div className="error-message">
            {error}
          </div>
        )}

        <button 
          type="submit" 
          className="submit-button" 
          disabled={!feedback.trim() || isSubmitting}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
        </button>
      </form>
    </div>
  );
}
